import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMultiselectInput} from "../abstract-multiselect-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterMultiselectInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-multiselect-input",
    styleUrls: ["../multiselect-input.scss"],
    templateUrl: "./filter-multiselect-input.component.html",
    standalone: false
})
export class FUIFilterMultiselectInputComponent extends FUIAbstractMultiselectInput {
    @Input() allowLabelMarkup: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
